import React, { useState } from "react";
import {
  AlertContext,
  RefreshContext,
  OfficialsContext,
} from "./contexts/AlertContext";
import MySnackBarContext from "./components/MySnackBar";
import MainRoutes from "./routes";
import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "bootstrap/dist/css/bootstrap.css";
import Footer from "./components/Footer";
import { Modal, Table } from "react-bootstrap";
import { Typography } from "@mui/material";
import { JsonToExcel } from "react-json-to-excel";

function App() {
  const [alertData, setAlertData] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState({ display: false, data: { list: [] } });
  const handleClose = () => {
    setShow({ display: false, data: { list: [] } });
  };
  return (
    <>
      <OfficialsContext.Provider value={{ show, setShow }}>
        <RefreshContext.Provider value={{ loading, setLoading }}>
          <AlertContext.Provider value={{ alertData, setAlertData }}>
            <MainRoutes />
            <Footer />
            <MySnackBarContext
              alertData={alertData}
              setAlertData={setAlertData}
            />
            <Modal
              show={show.display}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              centered
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>{show.data.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Table striped borderless>
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>Name</th>
                      <th>Institution</th>
                      <th>Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    {show.data.list.map((c, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          <Typography>{c.name}</Typography>
                        </td>
                        <td className="col-lg-6">
                          <Typography>{c.institution}</Typography>
                        </td>
                        <td>
                          <Typography>{c.code}</Typography>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <JsonToExcel
                  title="Download Data"
                  data={show.data.list}
                  fileName={show.data.title}
                />
              </Modal.Footer>
            </Modal>
          </AlertContext.Provider>
        </RefreshContext.Provider>
      </OfficialsContext.Provider>
    </>
  );
}

export default App;
